import type { HoneycombLabelsDisplay } from '../../../types/honeycomb.js';

export const shouldRenderLabels = (
  labelsDisplay: HoneycombLabelsDisplay | undefined,
): labelsDisplay is Exclude<HoneycombLabelsDisplay, 'none'> =>
  labelsDisplay !== undefined && labelsDisplay !== 'none';
